// import request from '@/utils/requests'
import axios from './http'

export function template (token) {
  return axios({
    method: 'post',
    url: '/api/Instruction/template',
    responseType: 'blob',
    headers: {
      'authorization': token
    }
  })
}

export function RecordSelect (token, pageNO, pageSize) {
  return axios({
    method: 'post',
    url: '/api/Instruction/RecordSelect',
    headers: {
      'authorization': token
    },
    params: { pageNO: pageNO, Pagesize: pageSize }
  })
}

export function RecordCounts (token, pageNO, pageSize) {
  return axios({
    method: 'post',
    url: '/api/Instruction/RecordCounts',
    headers: {
      'authorization': token
    }
  })
}

export function RecordAdd (token, instruction) {
  return axios({
    method: 'post',
    url: '/api/Instruction/RecordAdd',
    headers: {
      'authorization': token
    },
    data: instruction
  })
}
